<wj-popup #restartPopup [modal]="true" (keydown)="$event.preventDefault()" [showTrigger]="'None'" [hideTrigger]="'None'">
  <div class="modal-body">本日({{ date }})のマーケットデータの配信が開始しました。本日のデータに更新しますか。</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="reload()">はい</button>
    <button type="button" class="btn btn-light" (click)="restartPopup.hide()">いいえ</button>
  </div>
</wj-popup>
